import React from "react";
import { Link } from "react-router-dom";

const LOGO_DARK_BG = "/brp-logo-light.png";   // white/light logo for dark backgrounds
const LOGO_LIGHT_BG = "/brp-logo-dark.png";   // dark logo for paper/light backgrounds

/**
 * Official BRP Tech wordmark. Renders the raster PNG uploaded by the client.
 * `tone="dark"` selects the light-ink version for dark backgrounds; "light"
 * selects the dark-ink version for paper backgrounds. The intrinsic aspect
 * ratio of the logo (~2:1) is preserved; sizing controlled via `height`.
 */
export const BrpMark = ({ tone = "dark", height = 40, className = "" }) => {
  const src = tone === "dark" ? LOGO_DARK_BG : LOGO_LIGHT_BG;
  return (
    <img
      src={src}
      alt="BRP Tech"
      draggable={false}
      style={{ height, width: "auto", display: "block" }}
      className={`select-none ${className}`}
    />
  );
};

// Header/footer variant: just the logo, no extra tagline.
export const BrpLogo = ({ size = 36, tone = "dark" }) => (
  <BrpMark tone={tone} height={size} />
);

export const LogoLink = ({ testId, tone = "dark", size = 36 }) => (
  <Link to="/" data-testid={testId} className="inline-flex items-center brp-focus">
    <BrpLogo size={size} tone={tone} />
  </Link>
);
